import { useAppSelector } from "core/helpers/index";
import { UserPermissions } from "core/types/enums/PermissionsEnum";
import useAuth from "./useAuth";
import { GlobalAdminRole } from "../../components/tenants/helpers/isGlobalAdmin";

const useUserRole = () => {
  const { userCanViewRoute } = useAuth();
  const { currentUser } = useAppSelector(state => state.app);

  const userPermissions =
    currentUser?.roles?.[0] === GlobalAdminRole
      ? currentUser?.rolePermissions
      : currentUser?.rolePermissions || undefined;

  const permissionGranted = (allowedPermissions: UserPermissions[]) =>
    userCanViewRoute(allowedPermissions, userPermissions);

  const permissionGrantedAll = (requiredPermissions: UserPermissions[]) => {
    if (!userPermissions || !requiredPermissions.length) return false;
    return requiredPermissions.every(permission => userPermissions.includes(permission));
  };

  const permissionGrantedCheck = (allowedPermissions: UserPermissions[], isStrict?: boolean) => {
    if (isStrict) {
      if (!userPermissions || !allowedPermissions.length) return false;
      return allowedPermissions.every(permission => userPermissions.includes(permission));
    }
    return userCanViewRoute(allowedPermissions, userPermissions);
  };

  return {
    permissionGranted,
    permissionGrantedCheck,
    permissionGrantedAll,
    currentUser,
  };
};

export default useUserRole;
